module.exports = __webpack_public_path__ + "media/application/images/svgs/user-e42b4a8e3dd3488ecfcd0d6eb74ca9aa.svg";